import { gatherVideoInformation } from './VideoManager';

export default class ScrollyTellEngine {
  run() {
    gatherVideoInformation();
  }
}
